import React, { useEffect, useState } from 'react';
import codingBg from '../images/coding_bg.webp';

const HeroSection = ({ onExploreCourses, onBookDemoClick }) => {
  const [scrollY, setScrollY] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <section className="hero-section" style={{
      background: 'linear-gradient(135deg, #f0f8ff 0%, #e6f2ff 30%, #ddeeff 60%, #f5f9ff 100%)',
      width: '100vw',
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      padding: '0',
      position: 'relative',
      overflow: 'hidden',
      marginTop: '0'
    }}>

      <div className="floating-icon" style={{
        position:'absolute',
        top: '15%',
        left: '8%',
        animation: 'float 6s ease-in-out infinite'
      }}>
        <svg width="80" height="80" viewBox="0 0 24 24" fill="rgba(128,128,128,0.3)" style={{ filter: 'drop-shadow(2px 2px 4px rgba(128,128,128,0.2))' }}>
          <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19Z"/>
          <path d="M7 7H17V9H7V7M7 11H17V13H7V11M7 15H14V17H7V15Z"/>
        </svg>
      </div>
      <div className="floating-icon" style={{
        position: 'absolute',
        top: '70%',
        left: '12%',
        animation: 'float 8s ease-in-out infinite reverse'
      }}>
        <svg width="70" height="70" viewBox="0 0 24 24" fill="rgba(128,128,128,0.3)" style={{ filter: 'drop-shadow(2px 2px 4px rgba(128,128,128,0.2))' }}>
          <path d="M9,21C9,21 4,16.5 4,11A5,5 0 0,1 9,6A5,5 0 0,1 14,11C14,16.5 9,21 9,21M9,9A2,2 0 0,0 7,11A2,2 0 0,0 9,13A2,2 0 0,0 11,11A2,2 0 0,0 9,9M20,19H22V21H20V19M20,7V17H22V7H20Z"/>
        </svg>
      </div>
      <div className="floating-icon" style={{
        position: 'absolute',
        top: '25%',
        left: '30%',
        animation: 'float 7s ease-in-out infinite'
      }}>
        <svg width="75" height="75" viewBox="0 0 24 24" fill="rgba(128,128,128,0.3)" style={{ filter: 'drop-shadow(2px 2px 4px rgba(128,128,128,0.2))' }}>
          <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z"/>
        </svg>
      </div>

      <div className="floating-icon" style={{
        position: 'absolute',
        top: '80%',
        left: '35%',
        animation: 'float 5s ease-in-out infinite reverse'
      }}>
        <svg width="72" height="72" viewBox="0 0 24 24" fill="rgba(128,128,128,0.3)" style={{ filter: 'drop-shadow(2px 2px 4px rgba(128,128,128,0.2))' }}>
          <path d="M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V8A2,2 0 0,1 4,6H8V4A2,2 0 0,1 10,2M14,6V4H10V6H14Z"/>
        </svg>
      </div>
      <div className="floating-icon" style={{
        position: 'absolute',
        top: '50%',
        left: '38%',
        animation: 'float 9s ease-in-out infinite'
      }}>
        <svg width="67" height="67" viewBox="0 0 24 24" fill="rgba(128,128,128,0.3)" style={{ filter: 'drop-shadow(2px 2px 4px rgba(128,128,128,0.2))' }}>
          <path d="M4,6H20V16H4M20,18A2,2 0 0,0 22,16V6C22,4.89 21.1,4 20,4H4A2,2 0 0,0 2,6V16A2,2 0 0,0 4,18H0V20H24V18H20Z"/>
        </svg>
      </div>
      <style>
        {`
          @keyframes fadeInUp {
            0% {
              opacity: 0;
              transform: translateY(30px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes fadeInLeft {
            0% {
              opacity: 0;
              transform: translateX(-30px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }
          @keyframes slideInFromRight {
            0% {
              opacity: 0;
              transform: translateX(100%);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg) scale(1); }
            25% { transform: translateY(-25px) rotate(8deg) scale(1.1); }
            50% { transform: translateY(-40px) rotate(-5deg) scale(1.05); }
            75% { transform: translateY(-20px) rotate(5deg) scale(1.1); }
          }
          @media (max-width: 1024px) {
            .hero-content {
              padding: 3rem 2rem !important;
            }
            .hero-image {
              width: 45% !important;
            }
          }
          @media (max-width: 768px) {
            .hero-section {
              flex-direction: column !important;
              min-height: 50vh !important;
              padding: 1rem 1rem !important;
              background: linear-gradient(rgba(240,248,255,0.2), rgba(240,248,255,0.2)), url('../images/coding_bg.webp') !important;
              background-size: cover !important;
              background-position: center !important;
              background-repeat: no-repeat !important;
            }
          @media (max-width: 480px) {
            .hero-title {
              font-size: 2rem !important;
            }
            .hero-subtitle {
              font-size: 1rem !important;
            }
            .hero-section {
              padding: 0rem 1rem !important;
            }
          }
            .hero-content {
              width: 100% !important;
              padding: 0.5rem 1rem !important;
              min-height: auto !important;
              position: relative !important;
              z-index: 2 !important;
              margin-top: 0 !important;
            }
            .hero-content > div {
              margin-top: 0 !important;
            }
            .hero-title {
              font-size: 2.5rem !important;
              margin-bottom: 1.5rem !important;
              text-align: center !important;
            }
            .hero-subtitle {
              font-size: 1.1rem !important;
              margin-bottom: 2rem !important;
              text-align: left !important;
            }
            .hero-buttons {
              flex-direction: column !important;
              gap: 1rem !important;
              align-items: center !important;
            }
            .hero-buttons button {
              width: 180px !important;
              padding: 0.9rem 1.5rem !important;
              font-size: 0.95rem !important;
              white-space: nowrap !important;
            }
            .hero-image {
              display: none !important;
            }
            .floating-icon {
              display: none !important;
            }
          }
        `}
      </style>
      <div className="hero-content" style={{
        width: '50vw',
        padding: '1rem 2rem 4rem 4rem',
        textAlign: 'left',
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '80vh'
      }}>
        <div style={{ marginTop: '3rem' }}>
          <h1 className="hero-title" style={{ 
            fontSize: '3.5rem', 
            marginBottom: '1rem', 
            color: '#00315d', 
            fontWeight: '700',
            animation: 'fadeInUp 1s ease-out'
          }}>
            Learn. Build. Get Placed
          </h1>
          <p className="hero-subtitle" style={{ 
            fontSize: '1.3rem', 
            marginBottom: '3.5rem', 
            color: '#666', 
            maxWidth: '650px', 
            lineHeight: '1.6',
            animation: 'fadeInUp 1s ease-out 0.3s both'
          }}>
           Master in-demand IT skills with real-time projects and guaranteed placement assistance through expert training programs
          </p>
        </div>
        <div className="hero-buttons" style={{ 
          display: 'flex', 
          gap: '1.5rem',
          animation: 'fadeInLeft 1s ease-out 0.6s both'
        }}>
            <button onClick={onExploreCourses} style={{
              background: 'linear-gradient(135deg, #00315d 0%, #004080 50%, #0066cc 100%)',
              color: 'white',
              border: '2px solid rgba(255,255,255,0.2)',
              padding: '1rem 2rem',
              borderRadius: '25px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '600',
              boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.3), inset 0 -2px 4px rgba(0,0,0,0.2)',
              transition: 'all 0.3s ease'
            }} onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.filter = 'brightness(1.1)';
              e.target.style.boxShadow = 'inset 0 1px 2px rgba(255,255,255,0.4), inset 0 -1px 2px rgba(0,0,0,0.3)';
            }} onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.filter = 'brightness(1)';
              e.target.style.boxShadow = 'inset 0 2px 4px rgba(255,255,255,0.3), inset 0 -2px 4px rgba(0,0,0,0.2)';
            }}>Explore Courses</button>
            <button onClick={onBookDemoClick} style={{
              background: 'linear-gradient(135deg, #ff6b35 0%, #ff8c42 50%, #ffad5a 100%)',
              color: 'white',
              border: '2px solid rgba(255,255,255,0.2)',
              padding: '1rem 2rem',
              borderRadius: '25px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '600',
              boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.3), inset 0 -2px 4px rgba(0,0,0,0.2), 0 8px 16px rgba(255,107,53,0.3)',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }} onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05) translateY(-2px)';
              e.target.style.boxShadow = 'inset 0 1px 2px rgba(255,255,255,0.4), inset 0 -1px 2px rgba(0,0,0,0.3), 0 12px 24px rgba(255,107,53,0.4)';
              e.target.style.background = 'linear-gradient(135deg, #ff8c42 0%, #ffad5a 50%, #ffc971 100%)';
            }} onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1) translateY(0px)';
              e.target.style.boxShadow = 'inset 0 2px 4px rgba(255,255,255,0.3), inset 0 -2px 4px rgba(0,0,0,0.2), 0 8px 16px rgba(255,107,53,0.3)';
              e.target.style.background = 'linear-gradient(135deg, #ff6b35 0%, #ff8c42 50%, #ffad5a 100%)';
            }}>Book a Free Demo</button>
          </div>
        </div>
        
        <div className="hero-image" style={{
          width: '50vw',
          height: '80vh',
          position: 'absolute',
          right: 0,
          top: 0
        }}>
          <div 
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50% 0 0 50%',
              position: 'relative',
              boxShadow: '0 20px 40px rgba(0,49,93,0.2)',
              overflow: 'hidden',
              animation: 'slideInFromRight 1.5s ease-out 0.8s both'
            }}
          >
            <img 
              src={codingBg}
              alt="Professional IT training and coding courses in Chennai"
              width="800"
              height="600"
              fetchpriority="high"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                filter: 'sepia(30%) saturate(80%) hue-rotate(200deg) brightness(0.95)',
                transform: `scale(${1 + Math.min(scrollY * 0.0005, 0.3) + (isHovered ? 0.1 : 0)})`,
                transition: 'transform 0.3s ease'
              }}
            />
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, rgba(0,49,93,0.15) 0%, rgba(0,64,128,0.1) 50%, rgba(0,102,204,0.05) 100%)'
            }}></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;